exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1XgytkBgOCMVNpMRnVU98M {\n  background: #fff4;\n  border-radius: 4px;\n}\n\n._1XgytkBgOCMVNpMRnVU98M h2 {\n  width: 100%;\n  margin-top: 5px;\n  margin-left: 10px;\n}\n\n._4-EcLJgeHCjuYqZiNvuqi {\n  display: flex;\n  flex-flow: row wrap;\n}\n\n._4-EcLJgeHCjuYqZiNvuqi > * {\n  margin: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"Tremulator": "_1XgytkBgOCMVNpMRnVU98M",
	"TremulatorKnobs": "_4-EcLJgeHCjuYqZiNvuqi"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/typings-for-css-modules-loader/lib??ref--1-1!./styles/Tremulator.css
// module id = 211
// module chunks = 0